import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import App from './App';
import './styles/tokens.css';
import './styles/global.css';
import './styles/screens.css';
import './styles/editor.css';
import './styles/responsive.css';
import './styles/walld-leads.css';
import './styles/desktop-corrections.css';
import { LegalPage } from './features/legal/LegalPage';
import { I18nProvider } from './i18n/I18nProvider';

const WalldLeadsPage = lazy(() => import('./features/walld/WalldLeadsPage'));
const WebWidgetPage = lazy(() => import('./features/widget/WebWidgetPage'));

const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
const content = currentPath.startsWith('/legal/')
  ? <I18nProvider><LegalPage path={currentPath} /></I18nProvider>
  : currentPath === '/walld/leads'
  ? <Suspense fallback={<main className="walld-leads-auth" aria-busy="true"><div className="spinner" aria-label="Загружаем WALLD Leads" /></main>}><WalldLeadsPage /></Suspense>
  : currentPath === '/embed'
  ? <Suspense fallback={<main className="widget-shell" aria-busy="true"><div className="spinner" /></main>}><WebWidgetPage /></Suspense>
  : <I18nProvider><App /></I18nProvider>;

createRoot(document.getElementById('root')!).render(content);
